import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSoundIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 85,
	height: 85,
	viewBox: "0 0 85 85",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 18,
			width: 7,
			height: 49,
			rx: 3.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.5,
			y: 24,
			width: 7,
			height: 37,
			rx: 3.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22.5,
			y: 18,
			width: 7,
			height: 49,
			rx: 3.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 33.5,
			width: 7,
			height: 85,
			rx: 3.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 44.5,
			y: 10,
			width: 7,
			height: 65,
			rx: 3.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 55.5,
			y: 18,
			width: 7,
			height: 49,
			rx: 3.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 66.5,
			y: 24,
			width: 7,
			height: 37,
			rx: 3.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 77.5,
			y: 24,
			width: 7,
			height: 37,
			rx: 3.5,
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgSoundIcon);
export default ForwardRef;
